import { render, staticRenderFns } from "./formatedTextInput.vue?vue&type=template&id=aa913d8e&scoped=true&"
import script from "./formatedTextInput.vue?vue&type=script&lang=js&"
export * from "./formatedTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa913d8e",
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign({QInput}, component.options.components || {})
